/** ที่อยู่ API ไม่มี / ท้าย อ่านจาก VITE_API_URL (ดู .env.example) */
const DEV_FALLBACK = "https://api.dev.workcost.ai-innovation.click";

export function resolveApiUrl(raw: string | undefined, isDev: boolean): string {
  const v = (raw ?? "").trim() || (isDev ? DEV_FALLBACK : "");
  return v.replace(/\/+$/, "");
}

export const API_URL = resolveApiUrl(import.meta.env.VITE_API_URL as string | undefined, import.meta.env.DEV);
